export const APP_NAME = "FulfillFlow";
export const APP_TAGLINE = "SaaS Operations Platform for modern fulfillment.";

export * from "./navigation";
export * from "./reference";
